import {
    addDays, addMonths, endOfDay, endOfMonth, endOfWeek,
    isSameDay, startOfDay,
    startOfMonth, startOfWeek
} from 'date-fns';

export const defined = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
    startOfLast7Days: startOfDay(addDays(new Date(), -6)),
    startOfLast30Days: startOfDay(addDays(new Date(), -29)),
};

const staticRangeHandler = {
    range: {} as TDateRangeFunction,
    isSelected(range: any) {
        const definedRange = this.range();

        return (
            isSameDay(range.startDate, definedRange.startDate) &&
            isSameDay(range.endDate, definedRange.endDate)
        );
    },
};

export function createStaticRanges(ranges: TStaticDateRange[]) {
    return ranges.map(range => ({ ...staticRangeHandler, ...range }));
}

const dateRangConfig = {
    label: 'Last 7 days',
    range: () => ({
        startDate: defined.startOfLast7Days,
        endDate: defined.endOfToday,
    })
}

type TDateRangeConfig = typeof dateRangConfig




const YESTERDAY = {
    startDate: defined.startOfYesterday,
    endDate: defined.endOfYesterday,
}
const TODAY = {
    startDate: defined.startOfToday,
    endDate: defined.endOfToday,
}

const LAST_7_DAYS = {
    startDate: defined.startOfLast7Days,
    endDate: defined.startOfToday,
}

const LAST_30_DAYS = {
    startDate: defined.startOfLast30Days,
    endDate: defined.startOfToday
}

const dateRanges = (rangeTypes: TDateRangeType[]) => {
    const p: TDateRangeConfig[] = []
    return rangeTypes.reduce((acc, curr) => {
        switch (curr) {
            case "YESTERDAY":
                const y = {
                    label: 'Yesterday',
                    range: () => ({ ...YESTERDAY }),
                }
                return [...acc, y]
            case "TODAY":
                const t = {
                    label: 'Today',
                    range: () => ({
                        ...TODAY
                    }),
                }
                return [...acc, t]
            case "LAST_7_DAYS":
                const l7d = {
                    label: 'Last 7 days',
                    range: () => ({
                        ...LAST_7_DAYS
                    })
                }
                return [...acc, l7d]
            case "LAST_30_DAYS":
                const l30d = {
                    label: 'Last 30 days',
                    range: () => ({
                        ...LAST_30_DAYS
                    })
                }
                return [...acc, l30d]

            default:
                break;
        }
        return acc
    }, p)
}
const x = () => ({
    ...TODAY
})
export type TDateRangeFunction = typeof x

export type TDateRange = ReturnType<TDateRangeFunction>
export type TStaticDateRange = ReturnType<typeof dateRanges>[number]


export const getDefaultStaticRanges = (rangeTypes: TDateRangeType[]) => createStaticRanges(dateRanges(rangeTypes));


export const defaultInputRanges = [];


export type TDateRangeType =
    "TODAY" |
    "YESTERDAY" |
    "LAST_7_DAYS" |
    "LAST_30_DAYS" |
    "CUSTOM"

export const isCustomDateRange = (dateRanges: TDateRangeType[], range: TDateRange) => {
    const x = dateRanges.some((r) => {
        console.log(r)
        switch (r) {
            case 'YESTERDAY':
                return compareDateRange(range, YESTERDAY)
            case 'TODAY': return compareDateRange(range, TODAY)
            case 'LAST_7_DAYS': return compareDateRange(range, LAST_7_DAYS)
            case 'LAST_30_DAYS': return compareDateRange(range, LAST_30_DAYS)
            default:
                return false;
        }
    })
    return !x
}

const compareDateRange = (r1: TDateRange, r2: TDateRange) => {
    return isSameDay(r1.endDate, r2.endDate) && isSameDay(r1.startDate, r2.startDate)
}